import React from "react";
import type { ApolloClient } from "@apollo/client";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { push } from "store/actions/router";
import { isEmpty } from "lodash";

import TransactionsTable from "./TransactionsTable";
import "./Transactions.scss";
import IconSpinner from "components/IconSpinner";

import { getTransactions } from "actions/transactionActions";
import { transactionConstants } from "actions/types";
import { createErrorSelector } from "store/selectors";
import { getIraAccountIdSelector } from "store/selectors/user";
import { getAllAccounts } from "actions/accountActions";
import type { RootState } from "types/state";

const actions = [transactionConstants.GET_TRANSACTIONS];
const errorSelector = createErrorSelector(actions);

const mapStateToProps = (state: RootState) => {
  return {
    // narrow away `undefined` from the shallow-typed selector
    // (getIraAccountIdSelector returns string | null | undefined)
    iraAccountId: getIraAccountIdSelector(state) as string | null,
    transactions: state.transactions.transactions,
    error: errorSelector(state),
  };
};
const mapDispatchToProps = {
  push,
  getTransactions,
  getAllAccounts,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type Props = WithApolloClient<ConnectedProps<typeof connector>>;

interface State {
  initialFetching: boolean;
}

class Transactions extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { initialFetching: true };
  }

  componentDidMount() {
    if (isEmpty(this.props.iraAccountId)) {
      this.props.push("/dashboard?noAccount=true");
      return;
    }
    void this.props
      .getTransactions(
        this.props.client as ApolloClient<object>,
        this.props.iraAccountId as string
      )
      .then(() => {
        this.setState({ initialFetching: false });
      });
  }

  render() {
    const isFetching = this.state.initialFetching;
    return (
      <div className="transactions-mega-container">
        <section className="page-title-wrap">
          <article className="text-cell">
            <div>
              <h1 className="page-title">Transactions</h1>
              <p className="page-subtext">
                View transaction history or modify pending transactions.
              </p>
              <div className="transaction-card">
                {isFetching && <IconSpinner centered />}
                {!isFetching && <TransactionsTable />}
              </div>
            </div>
          </article>
        </section>
      </div>
    );
  }
}

export default connector(withApollo<Props>(Transactions));
